// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {Downloads} from '../../comp/downloads';
import {Text} from '../../comp/text';
import * as cns from './download_banner.module.less';

export function Download_banner({className}){
    return <div className={cn(cns.root, className)}>
      <div>
        <Text.l bold>Tasks on our Apps</Text.l>
        <div>
          <Text.xxxl bold span className={cns.earn}>Earn 11% more!</Text.xxxl>
          {' '}
          <Text.xxxl span bold>Download Now</Text.xxxl>
        </div>
      </div>
      <Downloads inline/>
    </div>;
}
